var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.classes,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('span',{class:_vm.iconClass}),_vm._v(_vm._s(_vm.followText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }